// EDITED 2026-08-28 - Civic Supply contact-form behaviour. This file now owns
// ONLY the post-submit thank-you modal.
//
// ⚠️ VALIDATION IS DELIBERATELY NOT DONE HERE ANY MORE. It used to be: this
// file set `novalidate` on the form to suppress the browser's popups, then
// re-implemented the required-field check in JavaScript. That turned out to be
// the source of a real bug - see FEATURE-NOTES.md - and on Denis's instruction
// (2026-08-28: "make sure the default is used... the less custom code from the
// default Horizon theme the better") the whole mechanism was removed in favour
// of the browser's own `required` checking.
//
// The three mandatory fields (Name / Email / Comment) carry plain `required`
// attributes in blocks/civicsupply-contact-form.liquid, so the browser blocks
// an empty submit itself - at click time, before Shopify's spam check can ever
// take the submission over. The maroon marking is now pure CSS hanging off the
// native `:user-invalid` state (civicsupply.css, "Contact form required
// fields"). No script, nothing to re-apply after a Horizon update, and it keeps
// working even if this file fails to load.
//
// ⚠️ DO NOT re-add `novalidate` or a JS submit guard here. Setting `novalidate`
// switches the browser's protection off, and that is exactly what opened the
// hole the first time.
(function () {
  if (window.civicSupplyContactInit) return;
  window.civicSupplyContactInit = true;

  // EDITED 2026-08-15 - true when the pending redirect belongs to the QUOTE form,
  // not this contact form. Checks BOTH signals so script order can't matter:
  //   - window.civicsupplyQuoteRedirect: set by civicsupply-quote-form.js once it
  //     has claimed the redirect (it loads AFTER this file, so on the first pass
  //     this is still undefined).
  //   - sessionStorage flag: written by the quote form at submit time and cleared
  //     by quote-form.js when it claims — so it is already readable here, before
  //     that file has run. Read-only on purpose: clearing it would rob
  //     quote-form.js of the signal it needs to show the quote thank-you.
  function quoteOwnsRedirect() {
    if (window.civicsupplyQuoteRedirect) return true;
    try { return sessionStorage.getItem('civicsupplyQuotePending') === '1'; } catch (e) { return false; }
  }

  // Thank-you modal shown after a successful submit (opened by JS only — see the
  // comment in blocks/civicsupply-contact-form.liquid for why Liquid must not
  // render data-open itself).
  function initModal() {
    var modal = document.querySelector('[data-civicsupply-modal]');
    if (!modal) return;

    // Move to <body> so position:fixed is reliable regardless of ancestor transforms/filters.
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    // EDITED 2026-06-11 - the quote form shares the contact pipe (and its
    // ?contact_posted=true redirect). When the redirect belongs to a quote
    // submission, stand down — the quote thank-you owns this one.
    if (quoteOwnsRedirect()) {
      modal.removeAttribute('data-open');
      return;
    }

    function onKey(e) {
      if (e.key === 'Escape' || e.key === 'Esc') close();
    }
    function close() {
      modal.removeAttribute('data-open');
      document.documentElement.classList.remove('civicsupply-modal-open');
      document.removeEventListener('keydown', onKey);
      // Strip the success param so a refresh doesn't reopen the modal.
      try {
        var u = new URL(window.location.href);
        if (u.searchParams.has('contact_posted')) {
          u.searchParams.delete('contact_posted');
          window.history.replaceState({}, '', u.pathname + (u.search || '') + u.hash);
        }
      } catch (e) {}
    }
    function open() {
      modal.setAttribute('data-open', 'true');
      document.documentElement.classList.add('civicsupply-modal-open');
      document.addEventListener('keydown', onKey);
      var focusTarget = modal.querySelector('.civicsupply-modal__button')
        || modal.querySelector('.civicsupply-modal__close');
      if (focusTarget) {
        try { focusTarget.focus(); } catch (e) {}
      }
    }

    modal.querySelectorAll('[data-civicsupply-modal-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    // Open when the URL carries the success param (?contact_posted=true) — this is what
    // survives Shopify's captcha redirect, and is now the ONLY trigger (Liquid no longer
    // renders data-open; see blocks/civicsupply-contact-form.liquid).
    // EDITED 2026-06-11 - decide AFTER all scripts have run (setTimeout 0):
    // civicsupply-quote-form.js loads at the end of <body> and claims the
    // shared redirect when it was a quote submission — without the delay this
    // modal opened too (double-modal bug found in testing).
    var postedParam = false;
    try { postedParam = new URLSearchParams(window.location.search).get('contact_posted') === 'true'; } catch (e) {}
    if (postedParam) {
      setTimeout(function () {
        if (quoteOwnsRedirect()) {
          modal.removeAttribute('data-open');
          return;
        }
        open();
      }, 0);
    }
  }

  function init() {
    initModal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
